// Move variant selector next to price on mobile
(function() {
  const MOBILE_BREAKPOINT = 750;
  let originalParent = null;
  let originalNextSibling = null;
  
  function moveVariantSelector() {
    const variantSelector = document.querySelector('.product__media-item-variant-selector');
    const priceElement = document.querySelector('.product-page-price');
    
    if (!variantSelector || !priceElement) return;
    
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    
    if (isMobile) {
      // Store original position if not already stored
      if (!originalParent) {
        originalParent = variantSelector.parentElement;
        originalNextSibling = variantSelector.nextElementSibling;
      }
      
      // Move variant selector after the price element
      if (priceElement.parentElement) {
        priceElement.parentElement.insertBefore(variantSelector, priceElement.nextSibling);
      }
    } else {
      // Restore to original position on desktop
      if (originalParent) {
        if (originalNextSibling) {
          originalParent.insertBefore(variantSelector, originalNextSibling);
        } else {
          originalParent.appendChild(variantSelector);
        }
      }
    }
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveVariantSelector);
  } else {
    moveVariantSelector();
  }
  
  // Run on resize with debounce
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(moveVariantSelector, 250);
  });
})();


// Update Product Promo Banner when price changes
(function() {
  function updatePromoBanner() {
    const promoBanner = document.querySelector('.product-promo-banner');
    if (!promoBanner) return;
    
    // Get the main product price element
    const mainPriceElement = document.querySelector('.product-page-price .price__sale .price-item--sale');
    const mainComparePriceElement = document.querySelector('.product-page-price .price__sale .price-item--regular');
    
    if (!mainPriceElement) return;
    
    // Update promo banner price
    const promoPriceElement = promoBanner.querySelector('[data-promo-price]');
    if (promoPriceElement) {
      const priceText = mainPriceElement.textContent.trim();
      promoPriceElement.textContent = priceText;
    }
    
    // Update discount badge
    const promoDiscountElement = promoBanner.querySelector('[data-promo-discount]');
    if (promoDiscountElement) {
      if (mainComparePriceElement) {
        // Parse prices to calculate discount percentage
        const priceValue = parseFloat(mainPriceElement.textContent.replace(/[^0-9.]/g, ''));
        const comparePriceValue = parseFloat(mainComparePriceElement.textContent.replace(/[^0-9.]/g, ''));
        
        if (comparePriceValue > priceValue) {
          const discountPercentage = Math.round(((comparePriceValue - priceValue) / comparePriceValue) * 100);
          
          // Show badge and update percentage
          promoDiscountElement.style.display = 'flex';
          const badgeText = promoDiscountElement.querySelector('.product-promo-banner__badge-text');
          if (badgeText) {
            badgeText.textContent = 'SAVE ' + discountPercentage + '%';
          }
        } else {
          // Hide badge if no discount
          promoDiscountElement.style.display = 'none';
        }
      } else {
        // Hide badge if no compare price
        promoDiscountElement.style.display = 'none';
      }
    }
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updatePromoBanner();
      setupPromoBannerObserver();
    });
  } else {
    updatePromoBanner();
    setupPromoBannerObserver();
  }
  
  // Set up MutationObserver to watch for price changes
  function setupPromoBannerObserver() {
    const priceContainer = document.querySelector('.product-page-price');
    
    if (!priceContainer) return;
    
    const observer = new MutationObserver(function(mutations) {
      updatePromoBanner();
    });
    
    // Observe changes to the price container and its children
    observer.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Also listen to variant change events
  document.addEventListener('variant:change', updatePromoBanner);
})();


(function() {
  function quantityDiscountBadge() {
    const quantityDiscountBadges = document.querySelectorAll('.quantity-discount-badge');

    if (!quantityDiscountBadges) return;

    const mainPriceElement = document.querySelector('.product-page-price .price__sale .price-item--sale');
    const mainComparePriceElement = document.querySelector('.product-page-price .price__sale .price-item--regular');
    
    if (!mainPriceElement) return;

    const priceValue = parseFloat(mainPriceElement.textContent.replace(/[^0-9.]/g, ''));
    const comparePriceValue = parseFloat(mainComparePriceElement.textContent.replace(/[^0-9.]/g, ''));

    const discountPercentage = Math.round(((comparePriceValue - priceValue) / comparePriceValue) * 100);

    quantityDiscountBadges.forEach(quantityDiscountBadge => {
      if (discountPercentage > 0) {
        quantityDiscountBadge.style.display = 'flex';
        quantityDiscountBadge.querySelector('.quantity-discount-badge__text').textContent = 'SAVE ' + discountPercentage + '%';
      } else {
        quantityDiscountBadge.style.display = 'none';
      }
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      quantityDiscountBadge();
      setupPromoBannerObserver();
    });
  } else {
    quantityDiscountBadge();
    setupPromoBannerObserver();
  }
  
  // Set up MutationObserver to watch for price changes
  function setupPromoBannerObserver() {
    const priceContainer = document.querySelector('.product-page-price');
    
    if (!priceContainer) return;
    
    const observer = new MutationObserver(function(mutations) {
      quantityDiscountBadge();
    });
    
    // Observe changes to the price container and its children
    observer.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Also listen to variant change events
  document.addEventListener('variant:change', quantityDiscountBadge);
})();
// gb-torch-customjs-clean-rollback-20260605T2059

(function () {
  var guaranteeText = '90-Day Money-Back Guarantee';
  var initialized = false;
  var rafId = null;
  var accordionRafId = null;

  function mainAtcButtons() {
    return document.querySelectorAll(
      '.product__info-container .product-form__buttons .atc-button.product-form__submit, .product__info-container .product-form__buttons .product-form__submit.main-product-atc'
    );
  }

  function addGuarantee() {
    mainAtcButtons().forEach(function (button) {
      button.classList.add('gb-atc-polished');

      var label = button.querySelector('.main-atc__label') || button;
      if (!label.querySelector('.gb-atc-guarantee')) {
        var guarantee = document.createElement('span');
        guarantee.className = 'gb-atc-guarantee';
        guarantee.textContent = guaranteeText;
        label.appendChild(guarantee);
      }
    });
  }

  function addRavenQuickViewGifts() {
    document.querySelectorAll('quick-add-modal product-info[data-url]').forEach(function (info) {
      var productUrl = info.getAttribute('data-url') || '';
      if (!/\/products\/raven(?:[?#]|$)/.test(productUrl) || info.querySelector('.gbg-qv')) return;

      var giftSection = document.createElement('section');
      giftSection.className = 'gbg-sec gbg-qv';
      giftSection.setAttribute('aria-label', 'Your free gifts');
      giftSection.innerHTML = [
        '<div class="gbg-box">',
        '<h3 class="gbg-title">Your Free Gifts</h3>',
        '<div class="gbg-gifts">',
        '<div class="gbg-gcard"><span class="gbg-free">FREE <s>$19</s></span><div class="gbg-img"><img src="https://cdn.shopify.com/s/files/1/0742/0769/0931/files/blaster-ebook-cover.png?v=1782340343&amp;width=240" alt="Gun Safety E-Book" loading="lazy"></div><div class="gbg-nm">Gun Safety E-Book</div></div>',
        '<div class="gbg-gcard"><span class="gbg-free">FREE <s>$15</s></span><div class="gbg-img"><img src="https://cdn.shopify.com/s/files/1/0742/0769/0931/files/blaster-gun-history-cover.png?v=1782443982&amp;width=240" alt="Gun History E-Book" loading="lazy"></div><div class="gbg-nm">Gun History E-Book</div></div>',
        '</div></div>'
      ].join('');

      var legacyGift = info.querySelector('.free-gift-banner');
      if (legacyGift && legacyGift.parentNode) {
        legacyGift.parentNode.replaceChild(giftSection, legacyGift);
        return;
      }

      var anchor = info.querySelector('[data-gb-membership],.gb-membership') ||
        info.querySelector('[data-stock]') ||
        info.querySelector('button[name="add"].main-product-atc,button[name="add"].product-form__submit');
      if (anchor) {
        while (anchor.parentNode && anchor.parentNode !== info) anchor = anchor.parentNode;
        if (anchor.parentNode === info) {
          /* Emi 2026-08-16: quick view must match the PDP order — Blaster Club card
             stays ABOVE the free-gifts box. The club root is moved under the stock
             note by gb-membership-blaster-club's placeBelowNote() before this runs,
             so anchor on the club when it is already sitting there. */
          var ref = anchor;
          var nxt = anchor.nextElementSibling;
          if (nxt && nxt !== giftSection &&
              ((nxt.matches && nxt.matches('[data-gb-membership],.gb-membership')) ||
               (nxt.querySelector && nxt.querySelector('[data-gb-membership]')))) {
            ref = nxt;
          }
          info.insertBefore(giftSection, ref.nextSibling);
          return;
        }
      }
      info.appendChild(giftSection);
    });
  }

  // Height of the sticky header (announcement/countdown bar height varies) so the target
  // lands just below it, not hidden underneath. Falls back to a sane default.
  function stickyHeaderOffset() {
    var h = document.querySelector('.shopify-section-group-header-group .section-header, .section-header, sticky-header, header.header');
    var hh = h ? h.getBoundingClientRect().height : 0;
    if (!hh || hh > window.innerHeight * 0.5) hh = 64; // guard against a non-sticky / oversized match
    return hh + 14; // small breathing room above the offer
  }

  // Land the shopper on the actual BUNDLE OFFER (Buy 1 / Buy 2 Most Popular / Buy 3) so they
  // can pick a tier, with ATC visible just below. Prefer the custom bundle box (.gbb); fall
  // back to the native quantity/bundle widget, then the ATC, then the info column.
  function offerTarget() {
    return (
      document.querySelector('.gbb, [data-gbb]') ||
      document.querySelector('.quantity-breaks, .bundle-deals, [id*="kaching_bundles_app_block"], .kaching-bundles__block') ||
      null
    );
  }

  function targetScrollY() {
    var offer = offerTarget();
    if (offer) {
      return Math.max(0, window.pageYOffset + offer.getBoundingClientRect().top - stickyHeaderOffset());
    }

    // No bundle offer on this product → keep the previous behavior (center the ATC).
    var atc = mainAtcButtons()[0];
    if (atc) {
      return Math.max(0, window.pageYOffset + atc.getBoundingClientRect().top - Math.round(window.innerHeight * 0.66));
    }

    var info = document.querySelector('.product__info-container');
    if (!info) return null;
    return Math.max(0, window.pageYOffset + info.getBoundingClientRect().top - 90);
  }

  function enhanceSticky() {
    document.querySelectorAll('.sticky-atc__scroll-btn').forEach(function (button) {
      button.classList.add('gb-sticky-polished');
    });
  }

  function polishFreeGift() {
    document.querySelectorAll('.product__info-container .free-gift-banner').forEach(function (banner) {
      banner.classList.add('gb-free-gift-polished');
    });
  }

  function hideRedundantTrustRow() {
    document.querySelectorAll('.product__info-container .icon-with-text').forEach(function (row) {
      var text = (row.textContent || '').replace(/\s+/g, ' ');
      if (text.indexOf('Fast Shipping') !== -1 && text.indexOf('Money Back') !== -1 && text.indexOf('24/7 Support') !== -1) {
        row.classList.add('gb-trust-row-hidden');
      }
    });
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function hasVisibleOpenAccordion() {
    if (!isMobileViewport()) return false;

    return Array.prototype.some.call(
      document.querySelectorAll('.product__info-container .product__accordion'),
      function (accordion) {
        var details = accordion.querySelector('.accordion__details[open]');
        var content = accordion.querySelector('.accordion__content-wrapper');
        if (!details || !content) return false;

        var rect = content.getBoundingClientRect();
        return rect.height > 20 && rect.bottom > 80 && rect.top < window.innerHeight - 40;
      }
    );
  }

  function syncAccordionStickyState() {
    document.body.classList.toggle('gb-accordion-reading', hasVisibleOpenAccordion());
  }

  function scheduleAccordionStickyState() {
    if (accordionRafId) return;
    accordionRafId = window.requestAnimationFrame(function () {
      accordionRafId = null;
      syncAccordionStickyState();
    });
  }

  function bindStickyScroll() {
    if (initialized) return;
    initialized = true;

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.sticky-atc__scroll-btn');
        if (!button) return;

        var y = targetScrollY();
        if (y === null) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        window.scrollTo({ top: y, behavior: 'smooth' });
      },
      true
    );
  }

  function run() {
    addGuarantee();
    addRavenQuickViewGifts();
    enhanceSticky();
    polishFreeGift();
    hideRedundantTrustRow();
    bindStickyScroll();
    syncAccordionStickyState();
    bindAddingFeedback();
  }

  // ===== GB "Adding…" button feedback (Emi idea 2026-06-23) — DISPLAY ONLY =====
  // On a real MAIN-product ATC click, swap the button label to "Adding" with animated dots so the
  // shopper knows the item is being added during the ~2s app chain (Kaching add → eg free-gift →
  // section render); the theme's real cart-drawer then opens with their items. It only changes the
  // button TEXT — never preventDefault/stopPropagation, never calls a cart endpoint — so it cannot
  // affect the cart or block a purchase. Capture-phase, self-guarded, fully degradable. Reverts when
  // the theme clears its .loading state (add resolved, success OR error), when the drawer opens, or
  // via a watchdog. Main ATC = .atc-button/#ProductSubmitButton- in .product__info-container (not upsell/sticky).
  var gbAddingBound = false;
  function bindAddingFeedback() {
    if (gbAddingBound) return;
    gbAddingBound = true;

    function mainAddButton(t) {
      if (!t || !t.closest) return null;
      var btn = t.closest('.product-form__submit, .atc-button, [id^="ProductSubmitButton"]');
      if (!btn) return null;
      if (t.closest('.sticky-atc__scroll-btn')) return null;                                                    // sticky = scroll-only
      if (btn.closest('[data-is-cart-upsell], cart-drawer-upsell, [id*="upsell"], [id*="Upsell"]')) return null; // exclude upsell/cross-sell forms
      if (!btn.closest('.product__info-container')) return null;                                                 // main ATC lives in the product info column
      if (btn.getAttribute('aria-disabled') === 'true' || btn.hasAttribute('disabled') || btn.getAttribute('data-unavailable') === 'true') return null;
      return btn;
    }

    document.addEventListener('click', function (e) {
      var btn = mainAddButton(e.target);
      if (!btn) return;
      if (btn.getAttribute('data-gb-adding') === '1') return;          // already running (double-click guard)
      var label = btn.querySelector('.main-atc__label__text');
      if (!label) return;
      var original = label.textContent;
      btn.setAttribute('data-gb-adding', '1');

      var n = 0;
      label.textContent = 'Adding';
      var iv = setInterval(function () { n = (n + 1) % 4; label.textContent = 'Adding' + new Array(n + 1).join('.'); }, 350);

      var done = false, classMO = null, drawerMO = null;
      function restore() {
        if (done) return; done = true;
        clearInterval(iv);
        if (classMO) classMO.disconnect();
        if (drawerMO) drawerMO.disconnect();
        if (/^Adding\.*$/.test(label.textContent)) label.textContent = original;   // don't clobber a theme re-render
        btn.removeAttribute('data-gb-adding');
      }
      // revert when the theme finishes its submit (Shrine toggles .loading on the button, removed on .finally)
      classMO = new MutationObserver(function () { if (!btn.classList.contains('loading')) restore(); });
      classMO.observe(btn, { attributes: true, attributeFilter: ['class'] });
      // revert when the cart-drawer opens (success)
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawerMO = new MutationObserver(function () { if (drawer.classList.contains('active')) restore(); });
        drawerMO.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
      // watchdog fail-safe — never let "Adding…" linger
      setTimeout(restore, 6000);
    }, true); // capture phase: runs before Shrine/Kaching handlers; we never stopPropagation/preventDefault
  }

  function scheduleRun() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('gb:quickview:ready', run);
  document.addEventListener('toggle', scheduleAccordionStickyState, true);
  window.addEventListener('scroll', scheduleAccordionStickyState, { passive: true });
  window.addEventListener('resize', scheduleAccordionStickyState);

  // perf (JS pass 2026-06-23): scope the re-run observer to #MainContent instead of the whole
  // document — every run() target (.product__info-container, .sticky-atc, .free-gift-banner,
  // .product__accordion, guarantee, trust row) lives inside it, so this preserves behavior while
  // no longer reacting to header/drawer/app-overlay/pixel DOM churn. Falls back to documentElement.
  new MutationObserver(scheduleRun).observe(
    document.getElementById('MainContent') || document.documentElement,
    { childList: true, subtree: true }
  );
})();


/* gbShipNextBusinessDay */
(function(){try{var tm=new Date(Date.now()+86400000).getDay();if(tm!==0&&tm!==6)return;var swap=function(){document.querySelectorAll('.bl-ship__line1').forEach(function(e){if(/ships tomorrow/i.test(e.textContent)){e.textContent='Order today \u2014 ships next business day';}});document.querySelectorAll('.gb-a2-trust__item strong').forEach(function(e){if(/SHIPS TOMORROW/.test(e.textContent)){e.textContent='\ud83d\ude9a SHIPS NEXT BUSINESS DAY';}});};swap();document.addEventListener('DOMContentLoaded',swap);document.addEventListener('gb:quickview:ready',swap);setTimeout(swap,1000);setTimeout(swap,3000);}catch(e){}})();
